/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserFlowFundsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    accountType: lc.get(data, 'account_type'),
    accountTypeDesc: lc.get(data, 'account_type_desc'),
    typeTransaction: lc.get(data, 'type_transaction'),
    typeTransactionTitle: lc.get(data, 'typeTransaction.title'),
    typeTransactionComment: lc.get(data, 'typeTransaction.comment'),
    sum: lc.get(data, 'sum'),
    comment: lc.get(data, 'comment'),
    modelClass: lc.get(data, 'model_class'),
    modelId: lc.get(data, 'model_id'),
    userId: lc.get(data, 'user_id'),
    referralId: lc.get(data, 'referral_id'),
    balance: lc.get(data, 'balance'),
    authorId: lc.get(data, 'author_id'),
    updaterId: lc.get(data, 'updater_id'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/services/UserFlowFundsService/restructuring/index.js